import { useEffect, useState } from 'react';

// True while the element is on (or just about to be on) the screen. Sections use it to pause
// endless animations and timers that nobody can see.
export const useOnScreen = (ref, margin = '150px') => {
  const [onScreen, setOnScreen] = useState(true);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') return undefined;

    const observer = new IntersectionObserver(([entry]) => setOnScreen(entry.isIntersecting), { rootMargin: margin });
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref, margin]);

  return onScreen;
};
